import { POLYGONS_OPACITY } from '@utils/map/map.constants';
import { FillLayerSpecification } from 'mapbox-gl';

import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';

export const jammingAreaLayer: FillLayerSpecification = {
  id: LayerNameEnum.TARGET_GCS_JAMMING,
  type: 'fill',
  source: SourceNameEnum.GCS_TARGETS,
  filter: ['==', 'featureType', FeatureTypeEnum.TARGET_GCS_JAMMING_AREA],
  paint: {
    'fill-color': ['get', 'color'],
    'fill-outline-color': 'black',
    'fill-opacity': POLYGONS_OPACITY,
  },
};
